import { SITE_ORIGIN } from "@/lib/video-seo";

/**
 * Make a root-relative URL absolute on the site origin.
 *
 * Open Graph and X (Twitter) card readers need an absolute og:image,
 * twitter:image and og:url. A value such as "/img/blog/x.webp" makes the
 * Open Graph tags incomplete. Absolute URLs and empty values pass through.
 */
export function absoluteUrl(url: string): string {
  if (url.startsWith("//")) return `https:${url}`;
  if (url.startsWith("/")) return `${SITE_ORIGIN}${url}`;
  return url;
}
